import { render, staticRenderFns } from "./SliptDropdownLink.vue?vue&type=template&id=cf42f280"
import script from "./SliptDropdownLink.vue?vue&type=script&lang=js"
export * from "./SliptDropdownLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports